<template>
  <div class="productUnderCategory">
    <a-breadcrumb>
      <a-breadcrumb-item>Home</a-breadcrumb-item>
      <a-breadcrumb-item>
        <router-link to="/products">Products</router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>
        <router-link :to="'/category/' + this.$route.params.cate">
          {{
          this.$route.params.cate
          }}
        </router-link>
      </a-breadcrumb-item>
    </a-breadcrumb>
    <article>
      <h3>{{ pUC.title }}</h3>
      <p class="markdown-body" v-html="pUC.text"></p>
    </article>

    <a-row>
      <a-col :span="24" class="cta-room">
        <router-link to="/contact" class="cta">
          <a-icon type="check" />&nbsp;&nbsp;Contact Us Now
        </router-link>
      </a-col>
    </a-row>
  </div>
</template>

<script>
// import axios from "axios";

export default {
  name: "ProductUnderCategory",
  data() {
    return {
      pUC: "",
      proName: "",
      description: undefined,
      keywords: undefined
    };
  },
  metaInfo() {
    return {
      title: this.proName,
      titleTemplate: null,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: this.description
        },
        {
          vmid: "keywords",
          name: "keywords",
          content: this.keywords
        }
      ]
    };
  },
  methods: {
    getPUC() {
      let queryLink =
        "https://rest.cnsian.com/api/post?slug=" + this.$route.params.name;
      fetch(queryLink)
        .then(res => res.json())
        .then(data => {
          this.pUC = data.data;
          this.proName = data.data.title;
          this.description = data.data.fields.Description.value;
          this.keywords = data.data.fields.Keywords.value;
        });
      // axios
      //   .get(queryLink)
      //   .then(res => {
      //     this.pUC = res.data.data
      //     this.proName = res.data.data.title
      //     this.description = res.data.data.fields.Description.value
      //     this.keywords = res.data.data.fields.Keywords.value
      //   });
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.getPUC();
      }
    }
  }
};
</script>

<style lang="scss">
@import url("https://cdnjs.cloudflare.com/ajax/libs/github-markdown-css/3.0.1/github-markdown.min.css");

.productUnderCategory {
  margin: 2em auto 10em auto;
  max-width: 75%;
  article {
    img {
      max-width: 100%;
      margin: 1em 0;
    }
  }
  .markdown-body {
    box-sizing: border-box;
    min-width: 200px;
    max-width: 980px;
    margin: 0 auto;
    padding: 45px;
    ul {
      display: flex;
      flex-direction: column;
      li {
        display: list-item;
        list-style: disc;
      }
    }
  }
  .cta-room {
    display: flex;
    justify-content: center;
    .cta {
      padding: 1em 2em;
      background-color: #3672f8;
      color: white;
      border-radius: 10px;
      font-size: 21px;
    }
  }

  @media (max-width: 767px) {
    .markdown-body {
      padding: 15px;
    }
  }
}
</style>
